import React, { Component } from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import scrollToComponent from 'react-scroll-to-component';
import ReactDOM from 'react-dom';
import Login from '../View/Login';
import BG from '../images/cmTable8IconBg.svg';
import '../css/table.css';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share'
const {
  FacebookShareButton,
  GooglePlusShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
const GooglePlusIcon = generateShareIcon('google');

class CMTable8 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      send: false,
      loading: false,
      ans1: false,
      ans2: false,
      ans3: false,
      ans4: false,
      ans5: false,
      ans6: false,
      ans7: false,
      name: '氣鬱質(H型)',
      totalTest:'',
      url: 'herbalcure.com.tw/CMTable8',
      thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86',
      fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86'
    }

    this.tableBox = this.tableBox.bind(this)
    this.handleChangeAns1 = this.handleChangeAns1.bind(this)
    this.handleChangeAns2 = this.handleChangeAns2.bind(this)
    this.handleChangeAns3 = this.handleChangeAns3.bind(this)
    this.handleChangeAns4 = this.handleChangeAns4.bind(this)
    this.handleChangeAns5 = this.handleChangeAns5.bind(this)
    this.handleChangeAns6 = this.handleChangeAns6.bind(this)
    this.handleChangeAns7 = this.handleChangeAns7.bind(this)
    this.goToTable2 = this.goToTable2.bind(this)
    this.goToTable3 = this.goToTable3.bind(this)
    this.goToTable4 = this.goToTable4.bind(this)
    this.goToTable5 = this.goToTable5.bind(this)
    this.goToTable6 = this.goToTable6.bind(this)
    this.goToTable7 = this.goToTable7.bind(this)
    this.tableSave = this.tableSave.bind(this)
  }
  componentDidMount() {
    window.scrollTo(0,0)
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        const totalTestTableRef = firebase.database().ref().child('total')
        totalTestTableRef.on('value', snap => {
          this.setState({
            totalTest: snap.val().totalTest
          })
        })
       console.log(this.state.totalTest)
      } else {
        tableBox.classList.remove('isShow')
      }
    })
  }
  tableBox() {
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        tableBox.classList.add('isShow')
        scrollToComponent(tableBox, {
        	offset: -50,
        	align: 'top',
        	duration: 700
        })
      } else {
        tableBox.classList.remove('isShow')
        this.setState({ send: true})
        setTimeout(() => this.setState({ loading: true }), 400);
      }
    })
  }
  goToTable2() {
    const table1 = ReactDOM.findDOMNode(this.refs.table1)
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    table1.classList.remove('isShow')
    table2.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable3() {
    const table2 = ReactDOM.findDOMNode(this.refs.table2)
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    table2.classList.remove('isShow')
    table3.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable4() {
    const table3 = ReactDOM.findDOMNode(this.refs.table3)
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    table3.classList.remove('isShow')
    table4.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable5() {
    const table4 = ReactDOM.findDOMNode(this.refs.table4)
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    table4.classList.remove('isShow')
    table5.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable6() {
    const table5 = ReactDOM.findDOMNode(this.refs.table5)
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    table5.classList.remove('isShow')
    table6.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  goToTable7() {
    const table6 = ReactDOM.findDOMNode(this.refs.table6)
    const table7 = ReactDOM.findDOMNode(this.refs.table7)
    table6.classList.remove('isShow')
    table7.classList.add('isShow')
    const tableBox = ReactDOM.findDOMNode(this.refs.tableBox)
    scrollToComponent(tableBox, {
      offset: -50,
      align: 'top',
      duration: 700
    })
  }
  tableSave(event) {
    event.preventDefault()
    const totalTestTableRef = firebase.database().ref().child('total')
    totalTestTableRef.update({
      totalTest: (this.state.totalTest * 1) + 1
    })
    const userId = firebase.auth().currentUser.uid
    const rootRef = firebase.database().ref('users/').child(userId).child('Answers').push()
    const postId = rootRef.key
    const total = ((this.state.ans1 * 1) + (this.state.ans2 * 1) + (this.state.ans3 * 1) + (this.state.ans4 * 1) + (this.state.ans5 * 1) + (this.state.ans6 * 1) + (this.state.ans7 * 1))
    const trans = [(total - 7) / (7 * 4)] * 100
    const getAns = Math.floor(trans)
    if(getAns < 30) {
      rootRef.update({
        Reviews: '您不屬於氣鬱體質',
        ans: getAns,
        name: '氣鬱質(H型)',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/CMTable8',
        localUrl: '/CMTable8',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86'
      })
    } else if (getAns < 39) {
      rootRef.update({
        Reviews: '您的體質傾向於氣鬱',
        ans: getAns,
        name: '氣鬱質(H型)',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/CMTable8',
        localUrl: '/CMTable8',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86'
      })
    } else {
      rootRef.update({
        Reviews: '您屬於氣鬱質(H型)',
        ans: getAns,
        name: '氣鬱質(H型)',
        createDate: new Date().toLocaleDateString(),
        createTime: new Date().toLocaleTimeString(),
        id: postId,
        url: 'herbalcure.com.tw/CMTable8',
        localUrl: '/CMTable8',
        thumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86',
        fbthumb: 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/newThumb%2FcmTable8.jpg?alt=media&token=45f1259a-c106-463b-976f-651263e59b86'
      })
    }
    window.location = ('/Answer/' + postId);
  }
  handleChangeAns1(event) {
    this.setState({ans1: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.add('is14-28')
    const toNext1 = ReactDOM.findDOMNode(this.refs.toNext1)
    scrollToComponent(toNext1, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns2(event) {
    this.setState({ans2: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is14-28')
    sliderBar.classList.add('is28-56')
    const toNext2 = ReactDOM.findDOMNode(this.refs.toNext2)
    scrollToComponent(toNext2, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns3(event) {
    this.setState({ans3: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is28-56')
    sliderBar.classList.add('is42-84')
    const toNext3 = ReactDOM.findDOMNode(this.refs.toNext3)
    scrollToComponent(toNext3, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns4(event) {
    this.setState({ans4: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is42-84')
    sliderBar.classList.add('is57-12')
    const toNext4 = ReactDOM.findDOMNode(this.refs.toNext4)
    scrollToComponent(toNext4, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns5(event) {
    this.setState({ans5: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is57-12')
    sliderBar.classList.add('is71-4')
    const toNext5 = ReactDOM.findDOMNode(this.refs.toNext5)
    scrollToComponent(toNext5, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns6(event) {
    this.setState({ans6: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is71-4')
    sliderBar.classList.add('is85-68')
    const toNext6 = ReactDOM.findDOMNode(this.refs.toNext6)
    scrollToComponent(toNext6, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  handleChangeAns7(event) {
    this.setState({ans7: event.target.value});
    const sliderBar = ReactDOM.findDOMNode(this.refs.sliderBar)
    sliderBar.classList.remove('is85-68')
    sliderBar.classList.add('is100')
    const toNext7 = ReactDOM.findDOMNode(this.refs.toNext7)
    scrollToComponent(toNext7, {
      offset: 150,
      align: 'top',
      duration: 700
    })
  }
  render(postId) {
    const { loading } = this.state;
    if(loading) {
      return <div style={{display: this.state.send ? 'flex' : 'none', background: '#eeede9',justifyContent: 'center', alignItems:'center'}} >
        <Login />
      </div>
    }
    const nextBtn1 = this.state.ans1
     ? <div className="nextTablebtnDefault" onClick={this.goToTable2}>下一題</div>
     : null
    const nextBtn2 = this.state.ans2
     ? <div className="nextTablebtnDefault" onClick={this.goToTable3}>下一題</div>
     : null
    const nextBtn3 = this.state.ans3
     ? <div className="nextTablebtnDefault" onClick={this.goToTable4}>再接再厲</div>
     : null
    const nextBtn4 = this.state.ans4
     ? <div className="nextTablebtnDefault" onClick={this.goToTable5}>快完成了</div>
     : null
    const nextBtn5 = this.state.ans5
     ? <div className="nextTablebtnDefault" onClick={this.goToTable6}>再接再厲</div>
     : null
    const nextBtn6 = this.state.ans6
     ? <div className="nextTablebtnDefault" onClick={this.goToTable7}>下一題</div>
     : null
    const nextBtn7 = this.state.ans7
     ? <div className="nextTablebtnDefault" onClick={this.tableSave}>完成!提交吧</div>
     : null
    return (
      <div>
        <MetaTags>
            <title>草學藥事 || {this.state.name}</title>
            <meta id="og-title" property="og:title" content={this.state.name} />
        </MetaTags>
        <div className="animationBox" style={Jeyu.Banner} ref="banner">
         <div className="container">
          <div className="row">
          <div style={Jeyu.Slogan} className="slogan cmTable8">
           <h1>氣鬱質(H型)</h1>
           <h2>神情抑鬱 憂慮脆弱</h2>
           <p className="moileNone">
           氣鬱體質的人給人一種惆悵、內心鬱悶的感覺<br />
           容易感到悶悶不樂，是憂鬱症的高危險群<br />
           氣機鬱滯，以神情抑鬱、憂慮脆弱等氣鬱表現為主要特徵
           </p>
           <span className="tableBtnDefault" onClick={this.tableBox}>開始檢測</span>
           <article className="fbBox">
                  <div className="Demo__some-network">
                     <FacebookShareButton
                       url='https://herbalcure.com.tw/CMTable8'
                       quote={this.state.name}
                       className="Demo__some-network__share-button">
                       <FacebookIcon
                         size={26}
                         round />
                     </FacebookShareButton>
                   </div>
                   <div className="Demo__some-network">
                     <GooglePlusShareButton
                       url='https://herbalcure.com.tw/CMTable8'
                       className="Demo__some-network__share-button">
                       <GooglePlusIcon
                         size={26}
                         round />
                     </GooglePlusShareButton>
                   </div>
           </article>
          </div>
          </div>
         </div>
        </div>
        <div className="tableBox table2Height" ref="tableBox" style={Jeyu.tableBox}>
         <div className="container">
          <div className="row">
          <div className="tableFlexBox">
           <div className="mobilePd20">
            <h2>氣鬱質(H型)</h2>
            <sub>請您根據最近半年以來身體與情緒的真正感覺，勾選最符合的一項!</sub>
           </div>
            <div className="sliderBar" ref="sliderBar"></div>
            <section className="">
             <form className="tableForm">
              <div className="table1 isShow" ref="table1">
              <article ref="toNext1">
               <h1>Q1:您感到悶悶不樂、情緒低沉嗎?</h1>
               <input type="radio" value='1'
                id="ans1"
                checked={this.state.ans1 === '1'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans1">沒有</label>
               <input type="radio" value='2'
                id="ans2"
                checked={this.state.ans1 === '2'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans2">很少</label>
               <input type="radio" value='3'
                id="ans3"
                checked={this.state.ans1 === '3'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans3">有時候</label>
               <input type="radio" value='4'
                id="ans4"
                checked={this.state.ans1 === '4'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans4">經常</label>
               <input type="radio" value='5'
                id="ans5"
                checked={this.state.ans1 === '5'}
                onChange={this.handleChangeAns1} />
               <label htmlFor="ans5">總是</label>
              </article>
               <div>{ nextBtn1 }</div>
              </div>
              <div className="table2" ref="table2">
              <article ref="toNext2">
               <h1>Q2:您容易精神緊張、焦慮不安嗎?</h1>
               <input type="radio" value='1'
                id="ans6"
                checked={this.state.ans2 === '1'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans6">沒有</label>
               <input type="radio" value='2'
                id="ans7"
                checked={this.state.ans2 === '2'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans7">很少</label>
               <input type="radio" value='3'
                id="ans8"
                checked={this.state.ans2 === '3'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans8">有時候</label>
               <input type="radio" value='4'
                id="ans9"
                checked={this.state.ans2 === '4'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans9">經常</label>
               <input type="radio" value='5'
                id="ans10"
                checked={this.state.ans2 === '5'}
                onChange={this.handleChangeAns2} />
               <label htmlFor="ans10">總是</label>
              </article>
               <div>{ nextBtn2 }</div>
              </div>
              <div className="table3" ref="table3">
              <article ref="toNext3">
               <h1>Q3:您多愁善感、感情脆弱嗎?</h1>
               <input type="radio" value='1'
                id="ans11"
                checked={this.state.ans3 === '1'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans11">沒有</label>
               <input type="radio" value='2'
                id="ans12"
                checked={this.state.ans3 === '2'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans12">很少</label>
               <input type="radio" value='3'
                id="ans13"
                checked={this.state.ans3 === '3'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans13">有時候</label>
               <input type="radio" value='4'
                id="ans14"
                checked={this.state.ans3 === '4'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans14">經常</label>
               <input type="radio" value='5'
                id="ans15"
                checked={this.state.ans3 === '5'}
                onChange={this.handleChangeAns3} />
               <label htmlFor="ans15">總是</label>
              </article>
               <div>{ nextBtn3 }</div>
              </div>
              <div className="table4" ref="table4">
              <article ref="toNext4">
               <h1>Q4:您容易感到害怕或受到驚嚇嗎?</h1>
               <input type="radio" value='1'
                id="ans16"
                checked={this.state.ans4 === '1'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans16">沒有</label>
               <input type="radio" value='2'
                id="ans17"
                checked={this.state.ans4 === '2'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans17">很少</label>
               <input type="radio" value='3'
                id="ans18"
                checked={this.state.ans4 === '3'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans18">有時候</label>
               <input type="radio" value='4'
                id="ans19"
                checked={this.state.ans4 === '4'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans19">經常</label>
               <input type="radio" value='5'
                id="ans20"
                checked={this.state.ans4 === '5'}
                onChange={this.handleChangeAns4} />
               <label htmlFor="ans20">總是</label>
              </article>
               <div>{ nextBtn4 }</div>
              </div>
              <div className="table5" ref="table5">
              <article ref="toNext5">
               <h1>Q5:您脅肋部或乳房脹痛嗎?</h1>
               <input type="radio" value='1'
                id="ans21"
                checked={this.state.ans5 === '1'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans21">沒有</label>
               <input type="radio" value='2'
                id="ans22"
                checked={this.state.ans5 === '2'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans22">很少</label>
               <input type="radio" value='3'
                id="ans23"
                checked={this.state.ans5 === '3'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans23">有時候</label>
               <input type="radio" value='4'
                id="ans24"
                checked={this.state.ans5 === '4'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans24">經常</label>
               <input type="radio" value='5'
                id="ans25"
                checked={this.state.ans5 === '5'}
                onChange={this.handleChangeAns5} />
               <label htmlFor="ans25">總是</label>
              </article>
               <div>{ nextBtn5 }</div>
              </div>
              <div className="table6" ref="table6">
              <article ref="toNext6">
               <h1>Q6:您無緣無故嘆氣嗎?</h1>
               <input type="radio" value='1'
                id="ans26"
                checked={this.state.ans6 === '1'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans26">沒有</label>
               <input type="radio" value='2'
                id="ans27"
                checked={this.state.ans6 === '2'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans27">很少</label>
               <input type="radio" value='3'
                id="ans28"
                checked={this.state.ans6 === '3'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans28">有時候</label>
               <input type="radio" value='4'
                id="ans29"
                checked={this.state.ans6 === '4'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans29">經常</label>
               <input type="radio" value='5'
                id="ans30"
                checked={this.state.ans6 === '5'}
                onChange={this.handleChangeAns6} />
               <label htmlFor="ans30">總是</label>
              </article>
               <div>{ nextBtn6 }</div>
              </div>
              <div className="table7" ref="table7">
              <article ref="toNext7">
               <h1>Q7:您咽喉部有異物感，且吐之不出、咽之不下嗎?</h1>
               <input type="radio" value='1'
                id="ans31"
                checked={this.state.ans7 === '1'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans31">沒有</label>
               <input type="radio" value='2'
                id="ans32"
                checked={this.state.ans7 === '2'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans32">很少</label>
               <input type="radio" value='3'
                id="ans33"
                checked={this.state.ans7 === '3'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans33">有時候</label>
               <input type="radio" value='4'
                id="ans34"
                checked={this.state.ans7 === '4'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans34">經常</label>
               <input type="radio" value='5'
                id="ans35"
                checked={this.state.ans7 === '5'}
                onChange={this.handleChangeAns7} />
               <label htmlFor="ans35">總是</label>
              </article>
               <div>{ nextBtn7 }</div>
              </div>
             </form>
            </section>
            </div>
          </div>
         </div>
        </div>
      </div>
    )
  }
}

export default CMTable8;

const Jeyu = {
  Banner: {
    background: 'url('+BG+') center center/ 120%',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Slogan: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid #325aaa',
    textAlign: 'center',
    padding: '20px 40px',
    flexDirection: 'column'
  },
  tableBox: {
    background: '#7FADE5'
  }
}



// WEBPACK FOOTER //
// ./src/Tables/cmTable8.js